export const ratePopContext = {
  rate_update: {
    header: 'ARate Check Algorithm optimization',
    body: ['We have optimized the algorithm of Rate'],
    btnTXT: 'OK',
  },
};
export default ratePopContext;



// WEBPACK FOOTER //
// ./src/components/rate/RateUpdate/config.js